var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pagesize-wrapper"},[_c('div',{staticClass:"pagesize-title"},[_vm._v(_vm._s(_vm.$t('listingPager.profilePageSize'))+":")]),_c('SprSimpleDropdown',{attrs:{"items":_vm.dropdownItems,"value":_vm.currentPageSize.toString(),"pager":true},on:{"input":_vm.pageSizeChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }